import React, { Suspense, memo, useCallback, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import Navbar from "./components/Navbar/Navbar";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";
import { PlatformSwitcher } from "@/components/PlatformSwitcher";
// import {
//   isPlatformSwitcherEnabled,
//   PLATFORM_SWITCHER_BAR_COLLAPSED_KEY,
// } from "@/config/platformSwitcher";
import styles from "./PostLogin.module.scss";

const PostLogin: React.FC = () => {
  const location = useLocation();
  // const switcherEnabled = isPlatformSwitcherEnabled();

  // const [bannerOpen, setBannerOpen] = useState(
  //   () =>
  //     switcherEnabled &&
  //     localStorage.getItem(PLATFORM_SWITCHER_BAR_COLLAPSED_KEY) !== "true"
  // );

  // const closeBanner = useCallback(() => {
  //   setBannerOpen(false);
  //   localStorage.setItem(PLATFORM_SWITCHER_BAR_COLLAPSED_KEY, "true");
  // }, []);

  // const openBanner = useCallback(() => {
  //   setBannerOpen(true);
  //   localStorage.setItem(PLATFORM_SWITCHER_BAR_COLLAPSED_KEY, "false");
  // }, []);

  return (
    <div className={styles.layout}>
      {/* {switcherEnabled && bannerOpen && (
        <PlatformSwitcher onClose={closeBanner} />
      )} */}
      <div className={styles.mainContent}>
        <Sidebar />
        <div className={styles.rightSideContainer}>
          <Navbar
            // showPlatformSwitcherIcon={switcherEnabled && !bannerOpen}
            // onOpenPlatformSwitcher={openBanner}
          />
          <div className={styles.outletDiv}>
            <Suspense fallback={<Loader />}>
              <ErrorBoundary>
                <Outlet key={location.pathname} />
              </ErrorBoundary>
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PostLogin);
